// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hNmK","inner":"Footer_inner__17jSK"};